import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useState, createElement } from "react";
import { getRadius, getSize, getFontSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { useMantineTheme } from "./auth-service-tools196.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { FloatingIndicator } from "./auth-service-tools310.js";
import classes from "./auth-service-tools403.js";
import { useMounted } from "./auth-service-tools404.js";
import { useUncontrolled } from "./auth-service-tools323.js";
import { useId } from "./auth-service-tools271.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {
  withItemsBorders: true
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    radius,
    color,
    transitionDuration,
    size,
    transitionTimingFunction
  } = _ref;
  return {
    root: {
      "--sc-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--sc-color": color ? getThemeColor(color, theme) : void 0,
      "--sc-shadow": color ? void 0 : "var(--mantine-shadow-xs)",
      "--sc-transition-duration": transitionDuration === void 0 ? void 0 : `${transitionDuration}ms`,
      "--sc-transition-timing-function": transitionTimingFunction,
      "--sc-padding": getSize(size, "sc-padding"),
      "--sc-font-size": getFontSize(size)
    }
  };
});
const SegmentedControl = factory((_props, ref) => {
  var _a, _b, _c, _d;

  const props = useProps("SegmentedControl", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    data,
    value,
    defaultValue,
    onChange,
    size,
    name,
    disabled,
    readOnly,
    fullWidth,
    orientation,
    radius,
    color,
    transitionDuration,
    transitionTimingFunction,
    variant,
    autoContrast,
    withItemsBorders,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "SegmentedControl",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  const theme = useMantineTheme();

  const _data = data.map(item => typeof item === "string" ? {
    label: item,
    value: item
  } : item);

  const initialized = useMounted();
  const [parent, setParent] = useState(null);
  const [refs, setRefs] = useState({});

  const setElementRef = (element, val) => {
    refs[val] = element;
    setRefs(refs);
  };

  const [_value, handleValueChange] = useUncontrolled({
    value,
    defaultValue,
    finalValue: Array.isArray(data) ? (_d = (_c = (_a = _data.find(item => !item.disabled)) == null ? void 0 : _a.value) != null ? _c : (_b = data[0]) == null ? void 0 : _b.value) != null ? _d : null : null,
    onChange
  });
  const uuid = useId(name);

  const controls = _data.map(item => /* @__PURE__ */createElement(Box, { ...getStyles("control"),
    mod: {
      active: _value === item.value,
      orientation
    },
    key: item.value
  }, /* @__PURE__ */createElement("input", { ...getStyles("input"),
    disabled: disabled || item.disabled,
    type: "radio",
    name: uuid,
    value: item.value,
    id: `${uuid}-${item.value}`,
    checked: _value === item.value,
    onChange: () => !readOnly && handleValueChange(item.value),
    "data-focus-ring": theme.focusRing,
    key: `${item.value}-input`
  }), /* @__PURE__ */createElement(Box, {
    component: "label",
    ...getStyles("label"),
    mod: {
      active: _value === item.value && !(disabled || item.disabled),
      disabled: disabled || item.disabled,
      "read-only": readOnly
    },
    htmlFor: `${uuid}-${item.value}`,
    ref: node => setElementRef(node, item.value),
    __vars: {
      "--sc-label-color": color !== void 0 ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0
    },
    key: `${item.value}-label`
  }, /* @__PURE__ */jsxRuntimeExports.jsx("span", { ...getStyles("innerLabel"),
    children: item.label
  }))));

  const mergedRef = useMergedRef(ref, node => setParent(node));

  if (data.length === 0) {
    return null;
  }

  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, { ...getStyles("root"),
    variant,
    size,
    ref: mergedRef,
    mod: [{
      "full-width": fullWidth,
      orientation,
      initialized,
      "with-items-borders": withItemsBorders
    }, mod],
    ...others,
    role: "radiogroup",
    "data-disabled": disabled,
    children: [typeof _value === "string" && /* @__PURE__ */jsxRuntimeExports.jsx(FloatingIndicator, {
      target: refs[_value],
      parent,
      component: "span",
      transitionDuration: "var(--sc-transition-duration)",
      ...getStyles("indicator")
    }), controls]
  });
});
SegmentedControl.classes = classes;
SegmentedControl.displayName = "@mantine/core/SegmentedControl";
export { SegmentedControl };